export type IndexingStepInfo = {
  step: number
  totalSteps: number
  description: string
}

export type HRListType = {
  id: string
  version: string
  displayName: string
  createdBy: string
  createdDate: string
  mappingCompleted: boolean
  isActive: boolean
  status?: boolean
  documentStatus: number
  isIndexing?: boolean
  indexingStep?: IndexingStepInfo
  isArchived?: boolean
  handleToggleSwitch: (id: string, isActive: boolean) => void
  showMapping: (id: string) => void
}
export type MappingItemType = {
  itemId: string
  text: string
  isMapped: boolean
  mappedId: string
  isSource: boolean
  handleMapping: (id: string) => void
  handleRemoveMapping: (id: string) => void
}

export enum HRDocumentStatusType {
    Uploading = 1,
		Temporary = 2,		
		MalwareScan = 4,
		ScanFailed = 5,
		ReadyForMapping = 6,
		MappingCompleted = 7,
}